import React, { useEffect, useState } from 'react';
import cuentaBancariaService, { cuentaLabel } from '../../services/cuentaBancaria.service';

/**
 * Loads the public bank accounts and keeps the selected one (preselected with the default).
 * `payload` is what to spread into the reservation request: { cuenta } or {} when there are none.
 */
export function useCuentasDestino() {
  const [cuentas, setCuentas] = useState([]);
  const [selected, setSelected] = useState('');

  useEffect(() => {
    let cancelled = false;
    cuentaBancariaService
      .getPublic()
      .then(list => {
        if (cancelled) return;
        setCuentas(list);
        const def = list.find(c => c.esDefault) || list[0];
        setSelected(prev => (prev && list.some(c => c._id === prev) ? prev : def?._id || ''));
      })
      .catch(() => {
        /* checkout keeps working without accounts — the server applies the default */
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { cuentas, selected, setSelected, payload: selected ? { cuenta: selected } : {} };
}

/** "Destino de la compra" select — only rendered when there are 2+ active accounts. */
export default function CuentaDestinoField({ cuentas, value, onChange, t }) {
  if (!cuentas || cuentas.length < 2) return null;
  return (
    <div className='space-y-1'>
      <label htmlFor='cuenta-destino' className='block text-sm font-medium text-ink'>
        {t('checkout.cuentaDestinoLabel', 'Destino de la compra')}
      </label>
      <select
        id='cuenta-destino'
        value={value}
        onChange={e => onChange(e.target.value)}
        className='w-full rounded-xl border border-divider bg-white px-3 py-2.5 text-sm text-ink focus:border-ink focus:outline-none focus:ring-1 focus:ring-ink/20'
      >
        {cuentas.map(c => (
          <option key={c._id} value={c._id}>
            {cuentaLabel(c)}
          </option>
        ))}
      </select>
      <p className='text-xs text-zinc-400'>
        {t('checkout.cuentaDestinoHint', '¿A quién querés apoyar con tu compra?')}
      </p>
    </div>
  );
}
